// extracted by mini-css-extract-plugin
module.exports = {"overlay":"ErrorModalTracker_overlay__2fzGm","root":"ErrorModalTracker_root__3zf3-","wrapper":"ErrorModalTracker_wrapper__3MgF5","title":"ErrorModalTracker_title__3kTl8"};